import React from 'react';
import { Text } from 'components';
import {} from './VendorNeedsToAcceptInviteTooltipContent.types';
const VendorNeedsToAcceptInviteTooltipContent = ({ partnerName, }) => (React.createElement(Text.Regular, null, `${partnerName} has to accept the invite before you can request tax information`));
export default VendorNeedsToAcceptInviteTooltipContent;
